import React, {Component} from "react";

export class ActivityIcon extends Component {
	activity() {
		// DepositActivityPresenter,WithdrawActivityPresenter,BuyActivityPresenter,SellActivityPresenter
		return this.props.activity;
	}

	activityAuthor() {
		return this.activity().activityAuthor();
	}

	loadIcon() {
		let activityIconFromAuthor = this.activityAuthor() ? this.activityAuthor().loadActivityIcon(this.activity()) : null;
		return activityIconFromAuthor || this.activity().icon();
	}

	render() {
		return (
			<figure className="icon">
				{this.loadIcon()}
			</figure>
		)
	}
}
